import { authSlice, ccb14Slice, logoutSlice, contractPDFSlice, additionalInfoSlice } from "../slice";

export const authActions = authSlice.actions;
export const logoutActions = logoutSlice.actions;
export const ccbActions = ccb14Slice.actions;
export const contractPDFActions = contractPDFSlice.actions;
export const additionalInfoActions = additionalInfoSlice.actions;
